import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Slide from '@material-ui/core/Slide';
import DialogContentText from '@material-ui/core/DialogContentText';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import active_lang from 'src/langs/jp_en';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { useSnackbar } from 'notistack';
import { ENQUEUE_SUCCESS_CONFIG } from 'src/consts/ENQUEUE_CONFIG';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UploadFileGamedays({
  open,
  setOpen,
  stadium_info,
  files,
  index,
  refetch,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [file, setFile] = useState(null);

  const handleClose = () => {
    setOpen(prevState => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  const handleFileChange = event => {
    const f = event.target.files[0];
    if (f) setFile(f);
  };

  const splitCSVLine = line => {
    const result = [];
    let cur = '';
    let inQuotes = false;
    for (let i = 0; i < line.length; i++) {
      const ch = line[i];
      if (ch === '"') {
        if (inQuotes && line[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      } else if (ch === ',' && !inQuotes) {
        result.push(cur);
        cur = '';
      } else {
        cur += ch;
      }
    }
    result.push(cur);
    return result;
  };

  const handleUpload = () => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async e => {
      const text = e.target.result;

      try {
        const lines = text.split(/\r\n|\n/).filter(l => l.trim() !== '');
        if (lines.length < 2) {
          console.warn('CSV contains no data rows');
        }

        const headers = splitCSVLine(lines[0]).map(h => h.trim().toLowerCase());
        const expected = [
          'date',
          'starttime_hh',
          'starttime_mm',
          'delivery_hh',
          'delivery_mm',
          'since_amount',
          'since_type',
          'until_amount',
          'until_type',
          'preorder',
        ];

        const missing = expected.filter(h => !headers.includes(h));
        if (missing.length) {
          console.error('CSV missing columns:', missing);
          return;
        }

        const headerIndex = {};
        expected.forEach(k => {
          headerIndex[k] = headers.indexOf(k);
        });

        const db = firebase.firestore();
        const baseDoc = db
          .collection('stadiums_gamedays')
          .doc(String(stadium_info.id));

        const baseSnap = await baseDoc.get();
        if (!baseSnap.exists) {
          await baseDoc.set(
            { createdAt: firebase.firestore.FieldValue.serverTimestamp() },
            { merge: true }
          );
        }

        const normalizeDate = raw => {
          if (!raw) return '';
          const s = raw.trim();
          if (s.indexOf('/') !== -1) {
            const parts = s.split('/').map(p => p.trim());
            if (parts.length === 3) {
              const [m, d, y] = parts;
              const mm = String(m).padStart(2, '0');
              const dd = String(d).padStart(2, '0');
              const yyyy = y.length === 2 ? '20' + y : y;
              return `${yyyy}-${mm}-${dd}`;
            }
          }
          if (s.indexOf('-') !== -1) {
            const parts = s.split('-').map(p => p.trim());
            if (parts.length === 3) {
              if (parts[0].length === 4) {
                const [y, m, d] = parts;
                const mm = String(m).padStart(2, '0');
                const dd = String(d).padStart(2, '0');
                return `${y}-${mm}-${dd}`;
              } else {
                const [m, d, y] = parts;
                const mm = String(m).padStart(2, '0');
                const dd = String(d).padStart(2, '0');
                const yyyy = y.length === 2 ? '20' + y : y;
                return `${yyyy}-${mm}-${dd}`;
              }
            }
          }
          const dt = new Date(s);
          if (!isNaN(dt.getTime())) {
            const yyyy = dt.getFullYear();
            const mm = String(dt.getMonth() + 1).padStart(2, '0');
            const dd = String(dt.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
          }
          return '';
        };

        const BATCH_LIMIT = 500;
        let batch = db.batch();
        let batchCount = 0;

        let availableFoodTrucks = [];
        try {
          const configsSnap = await db
            .collection('meny_manage_restaurant_config')
            .where('stadium_id', '==', stadium_info.id)
            .get();
          configsSnap.forEach(s => availableFoodTrucks.push(s.id));
        } catch (err) {
          console.error('Failed to load available_food_trucks:', err);
        }

        for (let i = 1; i < lines.length; i++) {
          const values = splitCSVLine(lines[i]);

          const obj = {};
          const getVal = key => {
            const idx = headerIndex[key];
            const raw = values[idx] !== undefined ? values[idx].trim() : '';
            return raw;
          };

          const dateValRaw = getVal('date');
          if (!dateValRaw) continue;
          const dateVal = normalizeDate(dateValRaw);
          if (!dateVal) {
            console.warn('Skipping row with invalid date:', dateValRaw);
            continue;
          }

          obj.date = dateVal;
          [
            'starttime_hh',
            'starttime_mm',
            'delivery_hh',
            'delivery_mm',
          ].forEach(k => {
            const v = getVal(k);
            obj[k] = v === '' ? '' : Number(v);
          });

          ['since_amount', 'until_amount'].forEach(k => {
            const v = getVal(k);
            obj[k] = v === '' ? '' : Number(v);
          });

          ['since_type', 'until_type'].forEach(k => {
            obj[k] = getVal(k);
          });

          const preorderRaw = getVal('preorder').toLowerCase();
          obj.preorder = ['1', 'true', 'yes', 'y'].includes(preorderRaw);

          if (availableFoodTrucks && availableFoodTrucks.length > 0) {
            obj.available_food_trucks = availableFoodTrucks;
          }

          const docRef = baseDoc.collection('gamedays').doc(String(dateVal));
          batch.set(docRef, obj, { merge: true });
          batchCount++;

          if (batchCount >= BATCH_LIMIT) {
            await batch.commit();
            batch = db.batch();
            batchCount = 0;
          }
        }

        if (batchCount > 0) await batch.commit();

        await baseDoc.set(
          { updatedAt: firebase.firestore.FieldValue.serverTimestamp() },
          { merge: true }
        );

        setFile(null);
        setOpen(prevState => {
          const newState = [...prevState];
          newState[index] = false;
          return newState;
        });
        enqueueSnackbar(
          active_lang.RESTAURANT_CONFIG_UPDATE_SUCCESS,
          ENQUEUE_SUCCESS_CONFIG
        );
        if (typeof refetch === 'function') refetch();
      } catch (error) {
        console.error('Save gamedays CSV to Firestore failed:', error);
      }
    };

    reader.onerror = err => console.error('File read error:', err);
    reader.readAsText(file);
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        maxWidth={'lg'}
        keepMounted
        onClose={handleClose}
        aria-labelledby="upload-gamedays-dialog"
      >
        <DialogTitle id="upload-gamedays-dialog">
          <Grid container>
            <Grid item md={12} style={{ textAlign: 'center' }}>
              <Box>Upload Gamedays CSV</Box>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <CardContent
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <input
                accept=".csv"
                style={{ display: 'none' }}
                id={`contained-button-file-gamedays-${stadium_info.id}`}
                type="file"
                onChange={handleFileChange}
              />
              <label
                htmlFor={`contained-button-file-gamedays-${stadium_info.id}`}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: '8px',
                }}
              >
                <Button variant="contained" color="primary" component="span">
                  Upload CSV File
                </Button>
              </label>
              {(files && files[index] && files[index].length > 0) || file ? (
                <Typography
                  variant="body2"
                  style={{ textAlign: 'center', marginTop: '10px' }}
                >
                  {stadium_info.id}.csv
                </Typography>
              ) : null}
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpload}
                disabled={!file}
                style={{ marginTop: '10px' }}
              >
                Upload to Firebase
              </Button>
            </CardContent>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {active_lang.ADMIN_USER_UPDATE_CANCEL}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
